<template>
    <div class="loading-spiner-overlay">
        <Circle2 background="#FFC93B"/>
    </div>
</template>

<script>
    import Circle2 from 'vue-loading-spinner/src/components/Circle2';
    export default {
        components: {
            Circle2
        },
        props: {
          size: {
            default: '40px'
          },
        },
    }
</script>
<style lang="scss" scoped>
    main.main .container-fluid{
        position: relative;
    }
    .loading-spiner-overlay{
        position: absolute;
        top: 0;
        bottom:0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.7);
        z-index: 1000;

        .spinner.spinner--rotate-square,.spinner.spinner--circle-2{
            position: absolute;
            top: 50%;
            left: 50%;
            margin-top: -20px;
            margin-left: -20px;
        }
    }

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/LoadingSpinner.vue